export function bidStatusIsHistorical({ status: { title }, archivedAt }) {
  return !!archivedAt || title !== 'active';
}
